export default __webpack_public_path__ + "static/media/happy-face-illustration1.2ebab787.png";